import Vue from 'vue'
import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import { Getters } from '../../store/editor/components/helpers'
import { IComponentData } from '../../store/editor/components/state'
import { PreviewContentType } from './PreviewInterface'

@Component({
  props: {
    id: {
      type: String,
      required: true
    },
    previewContentType: {
      type: String,
      required: false,
      default: 'internal'
    }
  }
})
export default class PreviewComponentVue<T extends IComponentData> extends Vue {
  $store: Store<RootState>
  id: string
  readonly previewContentType?: PreviewContentType

  get isExternalBuild(): boolean {
    return this.previewContentType === 'external'
  }

  get componentData(): T {
    return <T>this.getComponentData(this.id)
  }

  getComponentData(id: string): IComponentData {
    return Getters.componentFinder(this.$store)(id)
  }
}
